// eslint-disable-next-line
import { h, Component } from 'preact';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './index.scss';

class Placeholder extends Component {
    // disabling component update to preserve it's content
    // coming from external JS code
    shouldComponentUpdate = () => false;

    componentDidMount() {
        this.base.appendChild(this.props.el);
    }

    // toggle class implementation as IE11 does not support 3rd parameter
    toggleClass(el, name, isSet) {
        const cl = el.classList;
        const hasClass = cl.contains(name);
        if (isSet) {
            if (!hasClass) {
                cl.add(name);
            }
        } else if (hasClass) {
            cl.remove(name);
        }
    }

    // manage animation class changes since
    // automatic component update is disabled
    componentWillReceiveProps(nextProps) {
        this.toggleClass(this.base, styles.fadeOut, nextProps.fadeOut);
        this.toggleClass(this.base, styles.hide, nextProps.hide);
    }

    render() {
        const { fadeOut, hide, phId } = this.props;
        const elClasses = classNames({
            [styles.stickyElementPlaceholder]: true,
            [styles.fadeOut]: fadeOut,
            [styles.hide]: hide,
        });

        return <div key={phId} className={elClasses} />;
    }
}

Placeholder.propTypes = {
    el: PropTypes.object.isRequired,
    phId: PropTypes.string.isRequired,
    fadeOut: PropTypes.bool.isRequired,
    hide: PropTypes.bool.isRequired,
};

export default Placeholder;
